import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanDeactivateGuard } from 'src/app/guard/can-deactivate.guard';

const routes:Routes = [
  {
    path: 'partner',
    redirectTo: 'partner/main',
    pathMatch: 'full'
  },
  {
    path: 'partner/main',
    loadChildren: () => import('./main/main.module').then( m => m.MainPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'partner/sign-up',
    loadChildren: () => import('./sign-up/sign-up.module').then( m => m.SignUpPartnerPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'partner/worker-manage-list',
    loadChildren: () => import('./worker-manage-list/worker-manage-list.module').then( m => m.WorkerManageListPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'partner/today-tbm-list',
    loadChildren: () => import('./today-tbm-list/today-tbm-list.module').then( m => m.TodayTbmListPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'partner/notice-tbm',
    loadChildren: () => import('./notice-tbm/notice-tbm.module').then( m => m.NoticeTbmPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'partner/notice-tbm-edit',
    loadChildren: () => import('./notice-tbm-edit/notice-tbm-edit.module').then( m => m.NoticeTbmEditPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'partner/mypage',
    loadChildren: () => import('./mypage/mypage.module').then( m => m.MypagePageModule)
  },
  {
    path: 'partner/notice-emergency',
    loadChildren: () => import('./notice-emergency/notice-emergency.module').then( m => m.NoticeEmergencyPageModule)
  },
  {
    path: 'partner/notice-emergency-edit',
    loadChildren: () => import('./notice-emergency-edit/notice-emergency-edit.module').then( m => m.NoticeEmergencyEditPageModule)
  },
  {
    path: 'partner/worker-edit',
    loadChildren: () => import('./worker-edit/worker-edit.module').then( m => m.WorkerEditPageModule)
  },
  {
    path: 'partner/worker-hist',
    loadChildren: () => import('./worker-hist/worker-hist.module').then( m => m.WorkerHistPageModule)
  },
  {
    path: 'partner/worker-info',
    loadChildren: () => import('./worker-info/worker-info.module').then( m => m.WorkerInfoPageModule)
  },
  {
    path: 'partner/tbm-status',
    loadChildren: () => import('./tbm-status/tbm-status.module').then( m => m.TbmStatusPageModule)
  },
  {
    path: 'partner/today-tbm-all-list',
    loadChildren: () => import('./today-tbm-all-list/today-tbm-all-list.module').then( m => m.TodayTbmAllListPageModule)
  },
  {
    path: 'partner/today-tbm-all-worker-list',
    loadChildren: () => import('./today-tbm-all-worker-list/today-tbm-all-worker-list.module').then( m => m.TodayTbmAllWorkerListPageModule)
  },
  {
    path: 'partner/tbm-status-notice',
    loadChildren: () => import('./tbm-status-notice/tbm-status-notice.module').then( m => m.TbmStatusNoticePageModule)
  },
  {
    path: 'partner/tbm-status-riskfactor',
    loadChildren: () => import('./tbm-status-riskfactor/tbm-status-riskfactor.module').then( m => m.TbmStatusRiskfactorPageModule)
  },
  {
    path: 'partner/tbm-status-safestudy',
    loadChildren: () => import('./tbm-status-safestudy/tbm-status-safestudy.module').then( m => m.TbmStatusSafestudyPageModule)
  },
  {
    path: 'partner/today-tbm-list-day-labor',
    loadChildren: () => import('./today-tbm-list-day-labor/today-tbm-list-day-labor.module').then( m => m.TodayTbmListDayLaborPageModule)
  },
  {
    path: 'partner/today-tbm-all-worker-list-day-labor',
    loadChildren: () => import('./today-tbm-all-worker-list-day-labor/today-tbm-all-worker-list-day-labor.module').then( m => m.TodayTbmAllWorkerListDayLaborPageModule)
  },
  {
    path: 'partner/worker-info-day-labor',
    loadChildren: () => import('./worker-info-day-labor/worker-info-day-labor.module').then( m => m.WorkerInfoDayLaborPageModule)
  },
  {
    path: 'partner/worker-manage-list-day-labor',
    loadChildren: () => import('./worker-manage-list-day-labor/worker-manage-list-day-labor.module').then( m => m.WorkerManageListDayLaborPageModule)
  }
]

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ]
})
export class PartnerRoutingModule { }
